export default "__VITE_ASSET__DX_0R69W__"